import { Component, computed, effect, input, signal } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { TNil } from '@app/app.interface';
import { ICtaForm } from '@campaign-form/campaign-form.interface';
import { EPlatformFeature } from '@enums/campaign.enum';
import { TExpectedKpi } from '@interfaces/campaign-analytics.interface';
import { ICreator } from '@pages/creators/creators.interface';
import { IGamePlayDeliverableForm } from '../../deliverable-step/deliverable-list/game-play/game-play.interface';
import { IExecutionForm } from '../../execution-step/execution-list/execution/execution.interface';
import { ExecutionExpectedKpisComponent } from './execution-expected-kpis/execution-expected-kpis.component';

@Component({
  imports: [ExecutionExpectedKpisComponent],
  selector: 'app-execution-expected-kpi-list',
  templateUrl: './execution-expected-kpi-list.component.html',
})
export class ExecutionExpectedKpiListComponent {
  public readonly formArray = input.required<FormArray<FormGroup<IExecutionForm>>>();
  public readonly platformFeature = input.required<EPlatformFeature>();
  public readonly availableKpis = input.required<TExpectedKpi[] | null>();
  public readonly creatorId = input.required<string | TNil>();
  public readonly isCustomMode = input.required<boolean>();
  public readonly creators = input.required<ICreator[]>();
  public readonly ctaForm = input.required<FormGroup<ICtaForm>>();

  public readonly isAllExpanded = input<boolean>(false);
  public readonly isViewMode = input<boolean>(false);
  public readonly gamePlayValues = input<FormArray<FormGroup<IGamePlayDeliverableForm>>['value']>([]);

  // Wave 10 follow-up - ctaForm is already threaded down here, so its own id doubles as
  // ctaTemplateId for kpi events without needing a separate input from expected-kpi-step.
  public readonly ctaTemplateId = computed(() => this.ctaForm().get('id')?.value ?? undefined);

  public readonly visibleExecutionControls = computed(() => {
    this.formArrayValueVersion();

    return this.formArray().controls.filter((control) => {
      return (
        !control.value.exclusiveTo ||
        this.isViewMode() ||
        (this.isCustomMode() && control.value.exclusiveTo === this.creatorId())
      );
    });
  });

  private readonly formArrayValueVersion = signal<number>(0);

  constructor() {
    effect((onCleanup) => {
      const formArray = this.formArray();
      const formArraySubscription = formArray.valueChanges.subscribe(() => {
        this.formArrayValueVersion.update((version) => version + 1);
      });

      onCleanup(() => {
        formArraySubscription.unsubscribe();
      });
    });
  }
}
